//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
import EmptyDefaultText from "@/components/common/EmptyDefaultText";
import EmptyPartnerCard from "@/components/common/EmptyPartnerCard";

export default {
  name: "EmptyPartnersSlider",
  components: {
    EmptyPartnerCard,
    EmptyDefaultText,
  },
  props: {
    gap: {
      type: Number,
      default: () => 32
    },
    columns: {
      type: Number,
      default: () => 6
    }
  },
  computed: {
    ...mapGetters({
      width: 'viewport/width',
    }),
    style() {
      return {
        'grid-template-columns': `repeat(${this.columns}, 1fr)`,
        'grid-gap': `${this.gap}px`,
      }
    }
  },
  watch: {
    width() {
      this.$emit('set-wrapper-width', this.$refs['empty-partners-slider-wrapper']?.clientWidth)
      this.$emit('set-item-width', this.$refs['empty-partners-slider-item'][0]?.$el?.clientWidth)
    }
  },
  mounted() {
    this.$emit('set-wrapper-width', this.$refs['empty-partners-slider-wrapper']?.clientWidth)
    this.$emit('set-item-width', this.$refs['empty-partners-slider-item'][0]?.$el?.clientWidth)
  }
}
